// import React from 'react';
// import Indicate from './Indicate';

import { Arrow } from '../../../svg';
import { formatPercent } from '@/utils/numberUtils';

// const IndicateDown: React.FC<{ percent: number }> = ({ percent }) => {
//   return <Indicate percent={percent} color="#AE0000" direction="down" />;
// };

// export default IndicateDown;

interface Props {
  percent: string | number;
  className?: string;
}
const IndicateDown: React.FC<Props> = ({ percent, className }) => {
  return (
    <span
      className={`flex items-center justify-center bg-[#F8E6E6] rounded-full px-2 py-1 gap-[2px] ${className ? className : ''}`}
    >
      <span className="text-xs text-[#AE0000] font-medium font-[Inter] leading-4">
        {typeof percent === 'number'
          ? formatPercent(-Math.abs(percent))
          : `${percent}%`}
      </span>
      <Arrow className="rotate-180" stroke="#AE0000" />
    </span>
  );
};

export default IndicateDown;
